import { create } from 'domain';

const BASE_AUTH_PATH = 'auth';
const BASE_SETTING_PATH = 'setting';

export const PATH_PAGE = {
  root: '/',
  cancel: '/cancel',
  auth: {
    signIn: `/${BASE_AUTH_PATH}/sign-in`,
    vscode: `/${BASE_AUTH_PATH}/vscode`,
  },
  onBoard: '/onboard',
  dashboard: {
    root: '/dashboard',
    workspaceById: (id: string) => `/dashboard/${id}`,
    newWorkspace: '/dashboard/new',
    llm: {
      root: (id: string) => `/dashboard/${id}/llm-service`,
      credentials: (id: string) => `/dashboard/${id}/llm-service/credentials`,
      activity: (id: string) => `/dashboard/${id}/llm-service/activity`,
    },
    oneClickDeploy: {
      root: (id: string) => `/dashboard/${id}/one-click-deploy`,
      create: (id: string) => `/dashboard/${id}/one-click-deploy/create`,
      byId: {
        root: (id: string, deployId: string) =>
          `/dashboard/${id}/one-click-deploy/${deployId}`,
        deployments: (id: string, deployId: string) =>
          `/dashboard/${id}/one-click-deploy/${deployId}/deployments`,
        log: (id: string, deployId: string) =>
          `/dashboard/${id}/one-click-deploy/${deployId}/log`,
        usageAndCost: (id: string, deployId: string) =>
          `/dashboard/${id}/one-click-deploy/${deployId}/usage`,
        setting: (id: string, deployId: string) =>
          `/dashboard/${id}/one-click-deploy/${deployId}/setting`,
        activity: (id: string, deployId: string) =>
          `/dashboard/${id}/one-click-deploy/${deployId}/activity`,
      },
    },
    oneClickTraining: {
      root: (id: string) => `/dashboard/${id}/one-click-training`,
    },
    serverlessGPU: {
      root: (id: string) => `/dashboard/${id}/serverless-gpu`,
      byId: (id: string, projectId: string) => ({
        overview: `/dashboard/${id}/serverless-gpu/${projectId}/overview`,
        onboarding: `/dashboard/${id}/serverless-gpu/${projectId}/onboarding`,
        task: `/dashboard/${id}/serverless-gpu/${projectId}/tasks`,
        deploy: `/dashboard/${id}/serverless-gpu/${projectId}/deploy`,
        develop: `/dashboard/${id}/serverless-gpu/${projectId}/develop`,
        storage: `/dashboard/${id}/serverless-gpu/${projectId}/storage`,
        activity: `/dashboard/${id}/serverless-gpu/${projectId}/activity`,
        playground: `/dashboard/${id}/serverless-gpu/${projectId}/playground`,
        playgroundBlueprint: `/dashboard/${id}/serverless-gpu/${projectId}/playground-blueprint`,
        setting: `/dashboard/${id}/serverless-gpu/${projectId}/setting`,
      }),
      overview: (id: string) => `/dashboard/${id}/serverless-gpu/overview`,
      onboarding: (id: string) => `/dashboard/${id}/serverless-gpu/onboarding`,
      task: (id: string) => `/dashboard/${id}/serverless-gpu/tasks`,
      tokens: (id: string) => `/dashboard/${id}/serverless-gpu/tokens`,
      pricing: (id: string) => `/dashboard/${id}/serverless-gpu/pricing`,
      createProject: (id: string) =>
        `/dashboard/${id}/serverless-gpu/create-project`,
      blueprint: (id: string) => ({
        root: `/dashboard/${id}/serverless-gpu/blueprint`,
        byName: (path: string) =>
          `/dashboard/${id}/serverless-gpu/blueprint/item?name=${path}`,
      }),
    },
    ai: {
      root: (id: string) => `/dashboard/${id}/ai`,
      overview: (id: string) => `/dashboard/${id}/ai/overview`,
      credentials: (id: string) => `/dashboard/${id}/ai/credentials`,
      module: (id: string, moduleId: string) => ({
        root: `/dashboard/${id}/ai/${moduleId}`,
        overview: `/dashboard/${id}/ai/${moduleId}/overview`,
        playground: `/dashboard/${id}/ai/${moduleId}/playground`,
        activity: `/dashboard/${id}/ai/${moduleId}/activity`,
        pricing: `/dashboard/${id}/ai/${moduleId}/pricing`,
      }),
    },
    setting: {
      general: (id: string) => `/dashboard/${id}/setting/general`,
    },
  },

  setting: {
    workspaces: {
      root: `/${BASE_SETTING_PATH}/workspaces`,
    },
    profile: `/${BASE_SETTING_PATH}/profile`,
    tokens: `/${BASE_SETTING_PATH}/tokens`,
    payment: `/${BASE_SETTING_PATH}/payment`,
    serviceQuota: `/${BASE_SETTING_PATH}/service-quota`,
  },
};

export default PATH_PAGE;
